import { render, staticRenderFns } from "./AddPurchasebuyer.vue?vue&type=template&id=688e3cdf&"
import script from "./AddPurchasebuyer.vue?vue&type=script&lang=js&"
export * from "./AddPurchasebuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports